import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { PhoneNumber } from "@/components/General/PhoneNumber/phoneNumber.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatISO } from "@/utils/date";
import { noEmptyValueFormatter } from "@/utils/textUtils";

import EditProfileModal from "./Modal/modal.container";

type ProfileDetailProps = {
    customer: ComponentsCustomer;
};

const ProfileDetails = ({ customer }: ProfileDetailProps) => {
    const { t } = useGranite();

    const bonusCardNumber =
        customer.eBonusCardNumber || customer.bonusCardNumber;

    return (
        <div>
            {customer.customerType === ComponentsCustomerType.B2B && (
                <div className={cn("tw:mb-4")}>
                    <Row>
                        <Col
                            xs={6}
                            md={3}
                        >
                            <p> {t("profileDetails.label.companyname")}</p>
                        </Col>
                        <Col>
                            <p>{customer.companyName}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            xs={6}
                            md={3}
                        >
                            <p> {t("profileDetails.label.vat")}</p>
                        </Col>
                        <Col>
                            <p>{`${customer.vatNrPrefix}${customer.vatNr}`}</p>
                        </Col>
                    </Row>
                </div>
            )}

            <Row>
                <Col
                    xs={6}
                    md={3}
                >
                    <p> {t("profileDetails.label.firstname")}</p>
                </Col>
                <Col>
                    <p>{`${customer.firstName} ${customer.lastName}`}</p>
                </Col>
            </Row>
            <Row>
                <Col
                    xs={6}
                    md={3}
                >
                    <p> {t("profileDetails.label.phonenumber")}</p>
                </Col>
                <Col>
                    <p>
                        {noEmptyValueFormatter(
                            <PhoneNumber
                                phoneNumber={`${customer.phonePrefix}${customer.phone}`}
                            />,
                            customer.phone
                        )}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col
                    xs={6}
                    md={3}
                >
                    <p> {t("profileDetails.label.type")}</p>
                </Col>
                <Col>
                    <p>
                        {customer.customerType === ComponentsCustomerType.B2B
                            ? t("profileDetails.label.business")
                            : t("profileDetails.label.private")}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col
                    xs={6}
                    md={3}
                >
                    <p>{t("profileDetails.label.dateOfBirth")}</p>
                </Col>
                <Col>
                    <p>
                        {noEmptyValueFormatter(
                            formatISO(customer.dateOfBirth),
                            formatISO(customer.dateOfBirth)
                        )}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col
                    xs={6}
                    md={3}
                >
                    <p> {t("profileDetails.label.bonuscard")}</p>
                </Col>
                <Col>
                    <p>
                        {noEmptyValueFormatter(
                            bonusCardNumber,
                            bonusCardNumber
                        )}
                    </p>
                </Col>
            </Row>
            <Row className={cn("tw:mt-4")}>
                <Col>
                    <EditProfileModal />
                </Col>
            </Row>
        </div>
    );
};

export default ProfileDetails;
